import React from "react";
import InvoiceForm from "./forms";

// TODO: CHECK_IT
const CreateInvoice: React.FC = () => <InvoiceForm />;

export default CreateInvoice;
